import React, { useEffect, useState } from 'react'

const useGetOfficerList = () => {
    const [officerList, setOfficerList] = useState([])

    useEffect(() =>{
        try{
            fetch(
                process.env.REACT_APP_BASE_URL + "/users/getAllOfficer",
                {
                  method: "GET",
                  headers: { "Content-Type": "application/json" },
                }
              )
              .then((res) => res.json())
              .then((response) => {
                setOfficerList(response?.data)
                })
                .catch((Err) => {
                  console.log("Err while getting propertType", Err);
                });
        }catch(error) {
            console.log(error)
        }
    },[])
    
  return {officerList}
}

export default useGetOfficerList
